import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import Swal from "sweetalert2";
import * as globalSettingsService from "../../../services/globalsetting.services";
import Breadcrums from "../../../common/breadcrumbs";
import { handleServerValidations } from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import Loader from "../../../common/loader";
import { useTranslation } from "react-i18next";
import * as Yup from 'yup';

const WebAppSettings = () => {
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Web App", url: "" },
  ];

  useEffect(() => {
    globalSettingsService
      .Details()
      .then((response) => {
        setShowDefault(response && response.data ? response?.data : {});
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
        setDataLoaded(true);
      });
  }, [refresh]);

  const validationSchema = Yup.object().shape({});

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          validateOnChange={true}
          enableReinitialize
          initialValues={{
            stream_tab_visibility: showdefault?.stream_tab_visibility ?? true,
            product_tab_visibility: showdefault?.product_tab_visibility ?? true,
            home_section_visibility: showdefault?.home_section_visibility ?? true,
            show_favorites: showdefault?.show_favorites ?? false,
            show_my_activities: showdefault?.show_my_activities ?? false,
            show_notification_settings: showdefault?.show_notification_settings ?? false,
            show_access_invitations: showdefault?.show_access_invitations ?? false,
            show_business_dashboard: showdefault?.show_business_dashboard ?? false,
            show_business_streams: showdefault?.show_business_streams ?? false,
            show_purchase_leads: showdefault?.show_purchase_leads ?? false,
            show_my_teams: showdefault?.show_my_teams ?? false,
            show_packages: showdefault?.show_packages ?? false,
            show_package_history: showdefault?.show_package_history ?? false,
            show_whatsapp_button_product_details: showdefault?.show_whatsapp_button_product_details ?? false,
            show_user_stats: showdefault?.show_user_stats ?? false,
            show_ai_data_extraction: showdefault?.show_ai_data_extraction ?? false,
            show_facebook_stream: showdefault?.show_facebook_stream ?? true,
            show_youtube_stream: showdefault?.show_youtube_stream ?? true,
            show_twitch_stream: showdefault?.show_twitch_stream ?? true,
            show_recorded_stream: showdefault?.show_recorded_stream ?? true,
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitted(true);
            let formData = new FormData();

            // Because other fields are required by validator, we need to send them back.
            // Ideally we'd send them exactly as we got them.
            formData.append("address", showdefault.address || " ");
            formData.append("admin_email", showdefault.admin_email || "test@test.com");
            formData.append("social_media_details", JSON.stringify(showdefault.social_media_details || []));
            formData.append("phone_number", showdefault.phone_number || "0000000000");
            formData.append("copy_right_text", showdefault.copy_right_text || " ");
            formData.append("title", showdefault.title || " ");
            formData.append("banner_visibility", showdefault.banner_visibility || false);
            formData.append("maintenance_mode", showdefault.maintenance_mode || false);
            formData.append("show_invoice", showdefault.show_invoice ?? false);
            formData.append("play_store_url", showdefault.play_store_url || "");
            formData.append("app_store_url", showdefault.app_store_url || "");

            formData.append("stream_tab_visibility", values.stream_tab_visibility);
            formData.append("product_tab_visibility", values.product_tab_visibility);
            formData.append("home_section_visibility", values.home_section_visibility);
            formData.append("show_favorites", values.show_favorites);
            formData.append("show_my_activities", values.show_my_activities);
            formData.append("show_notification_settings", values.show_notification_settings);
            formData.append("show_access_invitations", values.show_access_invitations);
            formData.append("show_business_dashboard", values.show_business_dashboard);
            formData.append("show_business_streams", values.show_business_streams);
            formData.append("show_purchase_leads", values.show_purchase_leads);
            formData.append("show_my_teams", values.show_my_teams);
            formData.append("show_packages", values.show_packages);
            formData.append("show_package_history", values.show_package_history);
            formData.append("show_whatsapp_button_product_details", values.show_whatsapp_button_product_details);
            formData.append("show_user_stats", values.show_user_stats);
            formData.append("show_ai_data_extraction", values.show_ai_data_extraction);
            formData.append("show_facebook_stream", values.show_facebook_stream);
            formData.append("show_youtube_stream", values.show_youtube_stream);
            formData.append("show_twitch_stream", values.show_twitch_stream);
            formData.append("show_recorded_stream", values.show_recorded_stream);


            globalSettingsService
              .Add(formData)
              .then((response) => {
                if (response.success) {
                  setRefresh((prev) => !prev);
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => setSubmitted(false), 2000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
                setSubmitted(false);
              });
          }}
        >
          {({ values, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="main-content-label mb-0">Web App Settings</h6>
                        <div className="d-flex align-items-center">
                          <label className="mr-2 mb-0">Check All</label>
                          <label className={"custom-switch cp mb-0"}>
                            <input
                              className="custom-switch-input cp"
                              type="checkbox"
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                const fields = [
                                  "stream_tab_visibility",
                                  "product_tab_visibility",
                                  "home_section_visibility",
                                  "show_favorites",
                                  "show_my_activities",
                                  "show_notification_settings",
                                  "show_access_invitations",
                                  "show_business_dashboard",
                                  "show_business_streams",
                                  "show_purchase_leads",
                                  "show_my_teams",
                                  "show_packages",
                                  "show_package_history",
                                  "show_whatsapp_button_product_details",
                                  "show_user_stats",
                                  "show_ai_data_extraction",
                                  "show_facebook_stream",
                                  "show_youtube_stream",
                                  "show_twitch_stream",
                                  "show_recorded_stream",
                                ];
                                fields.forEach(field => setFieldValue(field, isChecked));
                              }}
                              checked={
                                values.stream_tab_visibility &&
                                values.product_tab_visibility &&
                                values.home_section_visibility &&
                                values.show_favorites &&
                                values.show_my_activities &&
                                values.show_notification_settings &&
                                values.show_access_invitations &&
                                values.show_business_dashboard &&
                                values.show_business_streams &&
                                values.show_purchase_leads &&
                                values.show_my_teams &&
                                values.show_packages &&
                                values.show_package_history &&
                                values.show_whatsapp_button_product_details &&
                                values.show_user_stats &&
                                values.show_ai_data_extraction &&
                                values.show_facebook_stream &&
                                values.show_youtube_stream &&
                                values.show_twitch_stream &&
                                values.show_recorded_stream
                              }
                            />
                            <span className="custom-switch-indicator cp"></span>
                          </label>
                        </div>
                      </div>
                      <div className="row row-sm">

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Stream Tab</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="stream_tab_visibility"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.stream_tab_visibility}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Product Tab</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="product_tab_visibility"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.product_tab_visibility}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Home Section</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="home_section_visibility"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.home_section_visibility}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Favorites</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_favorites"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_favorites}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show My Activity</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_my_activities"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_my_activities}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Notification Settings</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_notification_settings"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_notification_settings}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Access Invitations</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_access_invitations"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_access_invitations}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Business Dashboard</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_business_dashboard"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_business_dashboard}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Business Streams</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_business_streams"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_business_streams}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Purchase Leads</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_purchase_leads"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_purchase_leads}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show My Teams</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_my_teams"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_my_teams}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Packages</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_packages"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_packages}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Package History</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_package_history"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_package_history}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show WhatsApp Button (Products)</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_whatsapp_button_product_details"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_whatsapp_button_product_details}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show User Stats (Hours/Clicks)</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_user_stats"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_user_stats}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show AI Data Extraction</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_ai_data_extraction"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_ai_data_extraction}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Facebook Stream</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_facebook_stream"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_facebook_stream}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Youtube Stream</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_youtube_stream"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_youtube_stream}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Show Twitch Stream</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_twitch_stream"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_twitch_stream}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-4 text-center form-group">
                          <div className="d-flex align-items-start flex-column">
                            <label className="text-left d-flex">Allow Recorded Stream</label>
                            <label className={"custom-switch cp mt-2"}>
                              <input
                                className="custom-switch-input cp"
                                name="show_recorded_stream"
                                type="checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values?.show_recorded_stream}
                              />
                              <span className="custom-switch-indicator cp"></span>
                            </label>
                          </div>
                        </div>

                        <div className="col-md-12 mt-4">
                          <button
                            className="btn btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default WebAppSettings;
